import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BiCountryId } from "@globals/enums/BiLanguageAndCountryId";
import { TranslateLoader, TranslationObject } from "@ngx-translate/core";
import { Observable } from "rxjs";

/**
 * Custom translations loader that gets the translations from backend.
 */
@Injectable()
export class BiHttpTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    let languageId = BiCountryId.DK;

    if (lang === "se") languageId = BiCountryId.SE;
    if (lang === "en") languageId = BiCountryId.EN;
    if (lang === "fi") languageId = BiCountryId.FI;
    if (lang === "no") languageId = BiCountryId.NO;

    return this.http.get<TranslationObject>("/api/Common/GetResourcesJson", { params: { languageId } });
  }
}
